export const CAMPAIGN_LIST_EMPTY_MESSAGE =
  'エントリーできるキャンペーンはありません';

export const USER_CAMPAIGN_LIST_EMPTY_MESSAGE = 'データが存在しません';
